import styled from 'styled-components'
import { theme } from '../../../../theme/theme'
import { Title6 } from '../../../styles/Typography'
import { inputShadow } from '../../../../theme/shadows'
import { printCardOutline } from '../../../../theme/print'
import { NotEnoughScreeningData } from '../../../charts/NotEnoughData'

type Props = {
  title: string
  /** Absent when the API suppressed the metric; the tile then says so. */
  value?: string
}

export const MetricTile = ({ title, value }: Props) => {
  return (
    <Tile>
      <TileLabel>{title}</TileLabel>
      {value === undefined ? <NotEnoughScreeningData variant="tile" /> : <TileValue>{value}</TileValue>}
    </Tile>
  )
}

const Tile = styled.div`
  background: ${theme.color.white};
  border-radius: 16px;
  padding: ${theme.spacing.mediumLarge}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${theme.spacing.medium}px;
  ${inputShadow}
  ${printCardOutline}

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    padding: ${theme.spacing.medium}px;
  }

  @media print {
    break-inside: avoid;
  }
`

const TileLabel = styled(Title6)`
  color: ${theme.color.plum};
`

const TileValue = styled.span`
  font-family: ${theme.font.heading};
  font-size: ${theme.fontSize.jumbo}px;
  font-weight: 400;
  line-height: 1;
  color: ${theme.color.coral};
  font-variant-numeric: tabular-nums;
`
